module.exports = __webpack_public_path__ + "img/a10_02.00b44641.jpg";